module.exports = __webpack_public_path__ + "img/letter-header.a44a91f5.png";